"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _loglevel = _interopRequireDefault(require("loglevel"));

var _deepfind = _interopRequireDefault(require("./deepfind"));

var _themeContants = require("../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Apply variants for a component. Allows for multiple variants
 * @param themeProps
 * @returns {function} that styled-components uses in the resolving.
 */
var _default = function _default(themeProps) {
  return function (props) {
    var _props$variant = props.variant,
        variant = _props$variant === void 0 ? _themeContants.VARIANT_DEFAULT : _props$variant,
        theme = props.theme;

    if (!theme) {
      _loglevel["default"].warn("No theme!", variant);

      return null;
    }

    if (!themeProps) {
      _loglevel["default"].error("No theme props!", theme, variant, props);

      return null;
    }

    var name = themeProps.hasOwnProperty("name") ? themeProps.name : themeProps;

    if (!name) {
      _loglevel["default"].warn("No name!", variant, theme);

      return null;
    }

    return getVariants(theme, variant, name);
  };
};
/**
 * Get variants.
 * @example: resolveVariants(theme, "_default", "button", themeProps)
 * @param theme
 * @param variant - string, array, function or object
 * @param name - name of the style group e.g "button"
 * @returns {object, array}
 */


exports["default"] = _default;

var getVariants = function getVariants(theme, variant, name) {
  var type = _typeof(variant);

  if (Array.isArray(variant)) {
    return variant.map(function (v) {
      return getVariant(theme, v, name);
    });
  } else if (type === "function") {
    return getVariant(theme, variant({
      name: name,
      theme: theme
    }), name);
  } else if (type === "string") {
    return getVariant(theme, variant, name);
  } else if (type === "object") {
    var keys = Object.keys(variant);
    return keys.map(function (key) {
      return getVariant(theme, variant[key], key);
    });
  }

  return null;
};
/**
 * Get single variant.
 * @param theme
 * @param variant
 * @param name
 * @returns {object}
 */


var getVariant = function getVariant(theme, variant, name) {
  if (!variant) {
    return null;
  }

  if (!name) {
    return null;
  }

  var styles = (0, _deepfind["default"])(theme, name);

  if (!styles || !styles[variant]) {
    return null;
  }

  return styles[variant];
};